/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth__Login__TitleInputs */

const en_auth__login__title = /** @type {(inputs: Auth__Login__TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log in`)
};

/**
* | output |
* | --- |
* | "Log in" |
*
* @param {Auth__Login__TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const auth__login__title = /** @type {((inputs?: Auth__Login__TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth__Login__TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_auth__login__title(inputs)
});